module.exports = __webpack_public_path__ + "static/media/7195.8f4451b8.jpg";